import { render, staticRenderFns } from "./ClientHeaders.vue?vue&type=template&id=1504fa7e&scoped=true"
import script from "./ClientHeaders.vue?vue&type=script&lang=js"
export * from "./ClientHeaders.vue?vue&type=script&lang=js"
import style0 from "./ClientHeaders.vue?vue&type=style&index=0&id=1504fa7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1504fa7e",
  null
  
)

export default component.exports